import { SolicitacaoChatAreaResponsavelEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'
import { SolicitacaoChatMessageTypeEnum, ISolicitacaoChatMessage } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-message.interface'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ChatAgendamentoStore from './store/chat-agendamento-store'
import ChatAgendamentoModule from './chat-agendamento.module'

@Component({
  components: ChatAgendamentoModule.components,
})
export default class ComponentChatAgendamento extends Vue {
  channel: SolicitacaoChatAreaResponsavelEnum | string = '';
  canShowRightPanel = false
  solicitacaoChatAreaResponsavelEnum = SolicitacaoChatAreaResponsavelEnum

  mounted() {
    // Check can show right panel when starts based in screen width
    if (window.screen.availWidth > 600) {
      this.canShowRightPanel = true
    }
  }

  send(value: string) {
    const message = {
      tipo: SolicitacaoChatMessageTypeEnum.texto,
      texto: value,
    } as ISolicitacaoChatMessage

    this.chatStore.sendMessage(message)
  }

  sendAttachment(data: File) {
    this.chatStore.sendAttachment(data)
  }

  get attachmentLoading() {
    return this.chatStore.attachmentLoading
  }

  set attachmentLoading(value: boolean) {
    this.chatStore.setAttachmentLoading(value)
  }

  chooseChannel(channel: string) {
    this.channel = channel
    this.chatStore.setChatArea(channel as SolicitacaoChatAreaResponsavelEnum)
    this.ga('agendamento-medico', `escolher-canal-${channel}`)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async close() {
    await this.chatStore.closeChatModal()
    this.channel = ''
  }

  getMessageType(data: ISolicitacaoChatMessage) {
    if (data.tipoMensagem) {
      const messageType = data.tipoMensagem.key

      if (
        messageType === SolicitacaoChatMessageTypeEnum.texto
        || messageType === SolicitacaoChatMessageTypeEnum.anexo
      ) {
        return 'message'
      }
    }

    return 'marker'
  }

  getMessageSide(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    if (data.usuarioId === loggedUserId) {
      return 'right'
    }

    return 'left'
  }

  getCanShowFooter(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId === loggedUserId
      && messageType !== 'marker'
    ) {
      return true
    }

    return false
  }

  getSenderName(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.$user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId !== loggedUserId
      && messageType !== 'marker'
    ) {
      return data.usuarioNome
    }

    return ''
  }

  toggleRightPanel() {
    this.canShowRightPanel = !this.canShowRightPanel
  }

  formatDateForDay(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate} às ${hours}:${minutes}`
    }

    return ''
  }

  get canShowChooseChannel() {
    return !this.channel && this.needChooseChannel
  }

  get needChooseChannel() {
    return this.chatStore.finished || this.chatStore.finished == null
  }

  get chatStore() {
    return getModule(ChatAgendamentoStore, this.$store)
  }
}
